module.exports = __webpack_public_path__ + "static/img/RP_H5.76bb216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/RP_H5.png
// module id = A4Lp
// module chunks = 34